import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import ProfileBuilder from "@/pages/ProfileBuilder";
import Directory from "@/pages/Directory";
import ProfileView from "@/pages/ProfileView";
import Paywall from "@/pages/Paywall";
import ShowcaseProfile from "@/pages/ShowcaseProfile";
import Admin from "@/pages/Admin";
import Messages from "@/pages/Messages";
import Saved from "@/pages/Saved";
import Radio from "@/pages/Radio";
import Briefs from "@/pages/Briefs";
import Welcome from "@/pages/Welcome";
import SlugCard from "@/pages/SlugCard";
import { Terms, Privacy } from "@/pages/LegalPage";
import { MobileTabBar } from "@/components/MobileTabBar";
import { RadioProvider } from "@/context/RadioContext";
import { RadioDock } from "@/components/RadioDock";

function AppRouter() {
  const location = useLocation();
  // Handle Google OAuth callback FIRST, synchronously, before any route renders.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/auth" element={<Auth />} />
      <Route path="/showcase/:userId" element={<ShowcaseProfile />} />
      <Route path="/welcome" element={<Welcome />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/profile" element={<ProtectedRoute><ProfileBuilder /></ProtectedRoute>} />
      <Route path="/profile/:userId" element={<ProtectedRoute><ProfileView /></ProtectedRoute>} />
      <Route path="/directory" element={<ProtectedRoute><Directory /></ProtectedRoute>} />
      <Route path="/paywall" element={<ProtectedRoute><Paywall /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
      <Route path="/messages" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
      <Route path="/saved" element={<ProtectedRoute><Saved /></ProtectedRoute>} />
      <Route path="/radio" element={<ProtectedRoute><Radio /></ProtectedRoute>} />
      <Route path="/briefs" element={<ProtectedRoute><Briefs /></ProtectedRoute>} />
      <Route path="/:slug" element={<SlugCard />} />
      <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <RadioDock />
      <MobileTabBar />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <RadioProvider>
            <AppRouter />
          </RadioProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
